export default __webpack_public_path__ + "static/media/certificate.86b90213.jpg";